// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarRetornoNumerador,
  getRetornoNumeradorSelecionado,
  getRetornoNumerador,
} from "../../../../state";

export default function SelecaoRetornoNumerador() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"configuracaoRelatorio.numerador.retorno"}
        itensSelector={getRetornoNumerador}
        selectorItemSelecionado={getRetornoNumeradorSelecionado}
        onItemChange={selecionarRetornoNumerador}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
      />
    </div>
  );
}
